import { useParams } from "react-router-dom"
import InnerHeader from "../../Layouts/InnerHeader"
import Loading from "../../Layouts/Loading"
import { BlogRequest, useDeletePostMutation, useGetBlogCatsQuery, useGetPostQuery, useUpdatePostMutation } from "../../Redux/Apis/blogApi"
import { fa_date, fa_number } from "../../utils/Persian"
import { useEffect, useState } from "react"
import { toast } from 'react-toastify';
import Error404 from "../../Layouts/Error404"
import Blog from "./Blog"
import TextEditor from "../../Components/TextEditor"
import MediaGallery from "../../Components/MediaGallery"
import { FormImageGallery } from "../../Components/FormImageGallery"

export default function BlogEdit() {
    let {postId} = useParams();
    const [create,{isLoading : isPostLoading}] = useUpdatePostMutation()
    const [deletePost] = useDeletePostMutation()
    const [errorMsg, setErrorMsg] = useState<any>(false)
    const [isMediaGalleryOpen, setIsMediaGalleryOpen] = useState<boolean>(false);
    const handleImageSelection = (imageUrl: string): void => {
        setFormState((prev) => ({ ...prev, 'image': imageUrl }))
        setIsMediaGalleryOpen(false);
    };
    const [formState, setFormState] = useState<BlogRequest>({
        title:"",
        body:"",
        image:"",
        status:"",
        tags:"",
        excerpt:"",
        cat_id:NaN
    })

    const {
        data,
        isLoading,
        isSuccess,
        isError,
    } = useGetPostQuery(postId)
    const {
        data: categories,
        isLoading: isCatLoading,
    } = useGetBlogCatsQuery({})

    const handleChange = ({ target: { name, value },} : React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement> ) =>
        setFormState((prev) => ({ ...prev, [name]: value }))

    const onSubmit = async (e : React.FormEvent) => {
        e.preventDefault()
        try {
            await create(formState).unwrap()
            toast.success('تغییرات ذخیره شد!');
            setErrorMsg(false) 
        } catch (err:any){
            console.log(err);
            const message = !err.data ? '' : Array.isArray(err.data.message) ? err.data.message[0] : err.data.message
            setErrorMsg(message)                                     
        }
    }

    useEffect(() => {
        setFormState(data);
    }, [data])

    if(isLoading)
        return <Loading/>

    else if(isError)
        return <Blog/>

    else if(isSuccess && data) {
        return(
            <div className="container-lg">
                <InnerHeader name={`پست بلاگ | ${data.title}`}/>
                {errorMsg && <div className="alert alert-danger" role="alert">
                    {errorMsg}
                </div>}
                <div className="row">
                    <div className="col-md-8 col-sm-12 py-0 ps-0 pe-lg-3">
                        <form onSubmit={onSubmit} id="blogForm">
                            <div className="mb-3">
                                <label htmlFor="exampleFormControlInput1" className="form-label">موضوع پست</label>
                                <input type="text" name="title" className="form-control" id="exampleFormControlInput1" onChange={handleChange} defaultValue={data.title}/>
                            </div>
                        </form>
                        <TextEditor data={formState ? formState.body : ''} setFormState={setFormState} name='body'/>
                    </div>
                    <div className="col-md-4 col-sm-12 bg-light border mt-2 rounded-3 ms-auto p-2">
                    <form onSubmit={onSubmit} id="blogForm">
                        <ul className="list-group">
                            <li className="list-group-item">
                                <FormImageGallery _key='image' name='تصویر شاخص پست' value={formState ? formState.image : ''} input='image' openMediaGallery={setIsMediaGalleryOpen} url={data.url}/>
                            </li>
                            <li className="list-group-item">
                                <p className="float-start m-0">تاریخ ایجاد: </p>
                                <small className="float-end m-0">{fa_date(data.create_date)}</small>
                            </li>
                            <li className="list-group-item">
                                <p className="float-start m-0">تعداد بازدید: </p>
                                <small className="float-end m-0">{fa_number(data.views)}</small>
                            </li>
                            <li className="list-group-item">
                                <div className="mb-3">
                                    <label htmlFor="excerptInput" className="form-label">متن خلاصه (پیشنمایش)</label>
                                    <textarea name="excerpt" className="form-control" id="excerptInput" onChange={handleChange} defaultValue={data.excerpt} rows={3}/>
                                </div>
                            </li>
                            <li className="list-group-item">
                                <div className="mb-3">
                                    <label htmlFor="tagsInput" className="form-label">تگ ها (با کاما از هم جدا شوند):</label>
                                    <textarea name="tags" className="form-control" id="tagsInput" onChange={handleChange} defaultValue={data.tags} rows={2}/>
                                </div>
                            </li>
                            <li className="list-group-item">
                                <label className="form-label" htmlFor="inputGroupSelect01">دسته بندی</label>
                                <select name='cat_id' defaultValue={data.cat_id} onChange={(e) => setFormState((prev) => ({ ...prev, 'cat_id': +e.target.value }))} className="form-select" id="inputGroupSelect01">
                                    {
                                        isCatLoading ? 
                                            <option>انتخاب...</option>
                                        : 
                                            categories && Object.values(categories).map((value:any,index:number) => 
                                                <option value={value.id} key={index}>{value.name}</option> )
                                    }
                                </select>
                            </li>
                            <li className="list-group-item">
                                <div className="mb-3">
                                    <label htmlFor="statusInput" className="form-label">وضعیت انتشار</label>
                                    <select className="form-select" id="statusInput" name="status" aria-label="select status" onChange={handleChange} defaultValue={data.status}>
                                        <option>وضعیت پست را انتخاب نمایید</option>
                                        <option value="ACTIVE">منتشر شده</option>
                                        <option value="DEACTIVE">پیشنویس</option>
                                    </select>
                                </div>
                            </li>
                            <li className="list-group-item text-end">
                                <button onClick={() => window.confirm('آیا از حذف این پست اطمینان دارید؟') && deletePost(data.id)} className="btn btn-outline-danger me-2">حذف پست</button>
                                <button type="submit" form='blogForm' disabled={isPostLoading} className="btn btn-success">ذخیره تغییرات</button>
                            </li>
                        </ul>
                        </form>
                    </div>
                </div>
                {isMediaGalleryOpen && (
                    <MediaGallery
                        isOpen={isMediaGalleryOpen}
                        onClose={() => setIsMediaGalleryOpen(false)}
                        onImageSelect={handleImageSelection}
                    />
                )}
            </div>
        )
    }

    else return <Error404/>
}